import { create } from "zustand";
import { message } from "antd";

import AdminApiCaller from "../config/api/adminapicaller";

const initialState = {
  users: [],
  userCount: 0,
  expiredUsers: [],
  expiredUserCount: 0,
  maleUserCount: 0,
  femaleUserCount: 0,
  user: {},
  isLoading: false,
  isUserLoading: false,
  isDeleteLoading: false,
  error: null,
};

export const useUserStore = create((set, get) => {
  const setUser = (partial) => set((state) => ({ ...state, ...partial }));

  return {
    ...initialState,
    getUsers: async (payload, cb) => {
      try {
        setUser({ isLoading: true, error: null });
        const res = await AdminApiCaller.Post("/get-users", payload);
        if (res?.status === 200) {
          setUser({
            users: res.data.users,
            userCount: res.data.count,
            maleUserCount: res.data.totalMaleUsers,
            femaleUserCount: res.data.totalFemaleUsers,
            isLoading: false,
          });
        } else {
          setUser({ isLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setUser({ isLoading: false, error: err });
      }
    },
    getExpiredUsers: async (payload, cb) => {
      try {
        setUser({ isLoading: true, error: null });
        const res = await AdminApiCaller.Post("/get-expired-users", payload);
        if (res?.status === 200) {
          setUser({
            expiredUsers: res.data.expiredUsers,
            expiredUserCount: res.data.count,
            isLoading: false,
          });
        } else {
          setUser({ isLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setUser({ isLoading: false, error: err });
      }
    },
    getUser: async (payload, cb) => {
      try {
        setUser({ isUserLoading: true, error: null });
        const res = await AdminApiCaller.Get(
          `/get-user?username=${payload?.username}`
        );
        if (res?.status === 200) {
          setUser({ user: res.data.user, isUserLoading: false });
        } else {
          setUser({ user: {}, isUserLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setUser({ isUserLoading: false, error: err });
      }
    },
    updateUser: async (payload, cb) => {
      try {
        setUser({ isUserLoading: true, error: null });
        const res = await AdminApiCaller.Post("/update-user", payload);
        if (res?.status === 200) {
          message.success("Updated successfully.");
        }
        setUser({ isUserLoading: false });
        if (cb) cb(res?.data);
      } catch (err) {
        setUser({ isUserLoading: false, error: err });
      }
    },
    updateUsersStatus: async (payload, cb) => {
      try {
        setUser({ isLoading: true, error: null });
        const res = await AdminApiCaller.Post(
          "/update-user-status-multiple",
          payload
        );
        if (res?.status === 200) {
          message.success("Updated successfully.");
        }
        setUser({ isLoading: false });
        if (cb) cb(res?.data);
      } catch (err) {
        setUser({ isLoading: false, error: err });
      }
    },
    uploadPhoto: async (payload, cb) => {
      try {
        setUser({ isUserLoading: true, error: null });
        const res = await AdminApiCaller.Post("/media/uploadphoto", payload);
        setUser({ isUserLoading: false });
        if (cb) cb(res);
      } catch (err) {
        message.error("Network Error");
        setUser({ isUserLoading: false, error: err });
      }
    },
    uploadTrustBadge: async (payload, cb) => {
      try {
        setUser({ isUserLoading: true, error: null });
        const res = await AdminApiCaller.Post("/media/uploadidentity", payload);
        if (res?.status === 200) {
          message.success("Your trust badge has been sent for approval");
        } else {
          message.error("Something went wrong");
        }
        setUser({ isUserLoading: false });
        if (cb) cb(res);
      } catch (err) {
        message.error("Network Error");
        setUser({ isUserLoading: false, error: err });
      }
    },
    deleteChangeRequest: async (payload, cb) => {
      try {
        setUser({ isDeleteLoading: true, error: null });
        const res = await AdminApiCaller.Delete(
          `/delete-change-req?id=${payload?.id}`
        );
        if (res?.status !== 200) {
          message.error("Something went wrong");
        }
        setUser({ isDeleteLoading: false });
        await get().getUser(payload);
        if (cb) cb(res);
      } catch (err) {
        message.error("Network Error");
        setUser({ isDeleteLoading: false, error: err });
      }
    },
    reset: () => set(initialState),
  };
});
